import { render, staticRenderFns } from "./BusinessCoefficientIndex.vue?vue&type=template&id=2f1f51e5"
import script from "./BusinessCoefficientIndex.vue?vue&type=script&lang=js"
export * from "./BusinessCoefficientIndex.vue?vue&type=script&lang=js"
import style0 from "./BusinessCoefficientIndex.vue?vue&type=style&index=0&id=2f1f51e5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports